import axios from "@/plugins/axios";

// Perbelanjaan Isi Rumah Bulanan Purata — monthly household EXPENDITURE average.
// By default ALL years (incl. the latest) come from the precomputed
// `lampiran_negxdaerah(* xstrata / xkaum)` tables (TW_/W_purata_perbelanjaan columns,
// currently 2022 + 2024) so the figures match the official reference; a backend code
// toggle (LATEST_FROM_HID in getPerbelanjaanPurataLampiran.js) switches the latest year
// to a live calculation from the row-level `lampiran_hid_perbelanjaan` table. Years are discovered
// server-side and returned in `data.years`; each row carries a per-year `values`
// map. Same response shape as the income Purata page, so the view
// (perbelanjaanPurata.vue) mirrors bulananPurata.vue.
export default class perbelanjaanPurataServices {
  // params: { NG?, DP?, P (csv pusingan), S ("1"|"2"|"3"), W ("W"|"TW") }
  async getPerbelanjaanPurata(params = {}) {
    const res = await axios.get(
      `${process.env.VUE_APP_API_URL}/JadualAwalan/getPerbelanjaanPurataLampiran`,
      { params }
    );
    return (res.data && res.data.data) || {};
  }
}
